"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var react_router_dom_1 = require("react-router-dom");
var api_1 = __importStar(require("api"));
var ProductsCreateBar_1 = __importDefault(require("./ProductsCreateBar"));
var FilterBar_1 = __importDefault(require("components/common/table/FilterBar"));
var use_stores_1 = require("hooks/use-stores");
var ProductsTable_1 = __importDefault(require("./ProductsTable"));
var Pager_1 = __importDefault(require("components/common/table/Pager"));
var utils_1 = require("../../util/utils");
var use_dialog_1 = require("../../hooks/use-dialog");
var Dialog_1 = require("../Dialog");
var use_notification_1 = require("../../hooks/use-notification");
var Notification_1 = require("../Notification");
var TableHeading_1 = require("../common/table/TableHeading");
var Products = mobx_react_1.observer(function () {
    var _a = use_stores_1.useStores(), productsStore = _a.productsStore, prefsStore = _a.prefsStore, productPageStore = _a.productPageStore;
    var _b = react_1.useState(false), transition = _b[0], setTransition = _b[1];
    var _c = react_1.useState(prefsStore.data.productsTable.page - 1), offset = _c[0], setOffset = _c[1];
    var prefs = prefsStore.data.productsTable;
    var transitionTimeout = react_1.useRef(null);
    var dialog = use_dialog_1.useDialog();
    var notification = use_notification_1.useNotification();
    var history = react_router_dom_1.useHistory();
    var getProducts = function () {
        if (!productsStore.data || productsStore.data.length <= 0) {
            api_1.default.getProducts(offset + 1, prefs.perPage, (prefs.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefs.sort.name !== null ? prefs.sort.name : 'id'), prefs.search)
                .then(function (response) {
                productsStore.setData(response.data.products);
                productPageStore.setData(response.data.page);
                prefsStore.editData({
                    productsTable: __assign(__assign({}, prefs), { results: response.data.page.results })
                });
            })
                .catch(api_1.catchHandler);
        }
    };
    react_1.useEffect(function () {
        document.title = 'Shop CMS - Products';
        getProducts();
    }, []);
    var perPageHandler = function (value) {
        prefsStore.editData({
            productsTable: __assign(__assign({}, prefs), { perPage: value })
        });
        api_1.default.getProducts(offset + 1, value, (prefs.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefs.sort.name !== null ? prefs.sort.name : 'id'), prefs.search)
            .then(function (response) {
            productsStore.setData(response.data.products);
            productPageStore.setData(response.data.page);
        })
            .catch(api_1.catchHandler);
    };
    var searchHandler = function (value) {
        prefsStore.editData({
            productsTable: __assign(__assign({}, prefs), { search: value })
        });
        clearTimeout(transitionTimeout.current);
        transitionTimeout.current = setTimeout(function () {
            api_1.default.getProducts(1, prefs.perPage, (prefs.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefs.sort.name !== null ? prefs.sort.name : 'id'), value)
                .then(function (response) {
                productsStore.setData(response.data.products);
                productPageStore.setData(response.data.page);
            })
                .catch(api_1.catchHandler);
            if (productsStore.data.length >= 0) {
                prefsStore.editData({
                    productsTable: __assign(__assign({}, prefs), { page: 1, search: value })
                });
                setOffset(0);
            }
        }, 400);
    };
    var sortHandler = function (name, direction) {
        prefsStore.editData({
            productsTable: __assign(__assign({}, prefs), { sort: {
                    name: name,
                    direction: direction
                } })
        });
        api_1.default.getProducts(offset + 1, prefs.perPage, (direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (name !== null ? name : 'id'), prefs.search)
            .then(function (response) {
            productsStore.setData(response.data.products);
            productPageStore.setData(response.data.page);
        })
            .catch(api_1.catchHandler);
    };
    var pageHandler = function (page) {
        prefsStore.editData({
            productsTable: __assign(__assign({}, prefs), { page: page + 1 })
        });
        var max = Math.ceil((productPageStore.data === undefined ? prefsStore.data.productsTable.results : productPageStore.data.results) / prefs.perPage) - 1;
        if (page === offset)
            return;
        if (offset === max && page >= max)
            return;
        if (offset === 0 && page <= 0)
            return;
        // setTransition(true);
        clearTimeout(transitionTimeout.current);
        transitionTimeout.current = setTimeout(function () {
            setTransition(false);
            setOffset(utils_1.clamp(0, page, max));
        }, 200);
        api_1.default.getProducts(page + 1, prefs.perPage, (prefs.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefs.sort.name !== null ? prefs.sort.name : 'id'), prefs.search)
            .then(function (response) {
            productsStore.setData(response.data.products);
            productPageStore.setData(response.data.page);
        })
            .catch(api_1.catchHandler);
    };
    var deleteHandler = function (product) {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: 'Delete Product',
            description: "Are you sure you want to delete " + product.name + "?"
        }).then(function () {
            api_1.default.deleteProduct(product)
                .then(function () {
                productsStore.removeDataItem(product);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: 'Product has been deleted'
                });
            })
                .catch(api_1.catchHandler);
        });
    };
    var toggleLiveHandler = function (product) {
        api_1.default.editProduct({
            id: product.id,
            live: !product.live
        })
            .then(function (response) {
            productsStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: response.data.live ? 'Product is now live' : 'Product is now hidden'
            });
        })
            .catch(api_1.catchHandler);
    };
    var duplicateHandler = function (product) {
        api_1.default.duplicateProduct(product)
            .then(function (response) {
            productsStore.addDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: 'Product successfully duplicated'
            });
            history.replace("/products/edit/" + response.data.id + "?duplicate=true");
        })
            .catch(api_1.catchHandler);
    };
    return (react_1.default.createElement("div", { className: 'products page', "data-transition": transition },
        react_1.default.createElement(ProductsCreateBar_1.default, null),
        react_1.default.createElement(FilterBar_1.default, { label: 'Products', perPage: prefs.perPage, onPerPageChange: perPageHandler, searchValue: prefsStore.data.productsTable.search, onSearchChange: searchHandler }),
        react_1.default.createElement(ProductsTable_1.default, { sort: prefs.sort, data: productsStore.data, onChangeSort: sortHandler, onDelete: deleteHandler, onToggleLive: toggleLiveHandler, onDuplicate: duplicateHandler }),
        react_1.default.createElement(Pager_1.default, { itemsLength: productPageStore.data === undefined ? prefsStore.data.productsTable.results : productPageStore.data.results, offset: offset, perPage: prefs.perPage, onPrev: function () { return pageHandler(offset - 1); }, onNext: function () { return pageHandler(offset + 1); }, onPage: pageHandler })));
});
exports.default = Products;
